var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Event } from "../models/enums";
import { DataStore } from '../services/datastore.service';
import { EventBus } from '../services/eventbus.service';
let AppResetVerification = class AppResetVerification extends LitElement {
    constructor() {
        super();
        this._id = undefined;
        this._randomized = undefined;
        this.password = undefined;
        this.error = undefined;
        this.datastore = DataStore.getInstance();
        this.eventbus = EventBus.getInstance();
        this.datastore.clearData();
    }
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        this._id = this.location.params.id;
        this._randomized = this.location.params.randomized;
        this.datastore.resetUserVerification(this._id, this._randomized)
            .then((response) => {
            this.password = response.password;
            this.eventbus.dispatchEvent(Event.Toast, {
                text: "User verified successfully",
                classes: "fas fa-user",
                type: "is-info",
            });
            this.requestUpdate();
        })
            .catch((error) => {
            this.error = JSON.parse(error.body).errortext;
            this.eventbus.dispatchError(error);
            this.requestUpdate();
        });
    }
    login() {
        this.datastore.redirect('/login');
    }
    render() {
        return html `
      <div class="card">
        <div class="card-content">
          <div class="mt-2 mb-2">
            ${this.password ? html `
              Congratulations, your password has been reset to <span class="has-text-weight-bold">${this.password}</span><br>
              <br>
              A copy of the password is sent to your email as well.<br>
              <br>
              <div class="control mt-4">
                <button class="button is-primary" @click="${this.login}">
                  <span class="icon">
                    <i class="fas fa-unlock"></i>
                  </span>
                  <span>Login</span>
                </button>
              </div>
            ` : ''}
            ${this.error ? html `
              Reset failed with the following error<br>
              <br>
              <span class="has-text-weight-bold">${this.error}</span>
            ` : ''}
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    property()
], AppResetVerification.prototype, "location", void 0);
AppResetVerification = __decorate([
    customElement('app-reset-verification')
], AppResetVerification);
export { AppResetVerification };
//# sourceMappingURL=anon_reset_verification.js.map